module.exports = __webpack_public_path__ + "media/images/btn_add_stallionship-a81105a273365800bbc9b318b4c4d923.gif";